import { Button } from "components/DesignSystem/Button/Button";
import { EditSensitiveDataDynamicForm } from "components/SensitiveData/SensitiveData";
import { REQUESTED, SUBMITTED } from "constants/sensitiveData";
import { useModal } from "hooks/useModal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useDispatch } from "react-redux";
import { actionItemsApi } from "store/apis/actionItems";

type SensitiveDataCardProps = {
  customData: {
    description: string | null;
    header: string;
    card_status: typeof REQUESTED | typeof SUBMITTED;

    metadata: {
      name: string;
      sensitive_data_instance_id: string;
      entity_id: string;
      shared_profiles: { profile_id: string; name: string }[] | null;
    };
  };
  customText?: string;
};

export const SensitiveDataCTA = ({
  customData,
  customText,
}: SensitiveDataCardProps) => {
  const { metadata, card_status } = customData || {};
  const {
    sensitive_data_instance_id,
    entity_id,
    name: formName,
    shared_profiles,
  } = metadata || {};
  const { isCustomer, isAdmin } = useRoleBasedView();
  const dispatch = useDispatch();

  const {
    isOpen: isEditOpen,
    open: openEditModal,
    close: closeEditModal,
  } = useModal();

  const close = () => {
    closeEditModal();
  };

  if (customText) {
    return (
      <div className="t-w-full t-gap-3">
        {card_status == REQUESTED && (
          <Button block onClick={openEditModal} size="small">
            {customText}
          </Button>
        )}
        {isEditOpen && (
          <EditSensitiveDataDynamicForm
            formId={sensitive_data_instance_id}
            isOpen={isEditOpen}
            close={close}
            entityId={entity_id!}
          />
        )}
      </div>
    );
  }
  return (
    <>
      <div className="t-w-full t-gap-3">
        {card_status == REQUESTED && isCustomer && (
          <Button
            block
            customType="primary"
            onClick={openEditModal}
            size="small"
          >
            Add details
          </Button>
        )}
        {card_status == REQUESTED && isAdmin && (
          <Button block onClick={openEditModal} size="small">
            Edit details
          </Button>
        )}
      </div>
      {isEditOpen && (
        <EditSensitiveDataDynamicForm
          formId={sensitive_data_instance_id}
          isOpen={isEditOpen}
          close={close}
          entityId={entity_id!}
        />
      )}
    </>
  );
};
